import _ from 'lodash';
import environment from '../../environments';
import { HazardExportEntity, HazardRisk } from './Hazard.interface';

const isBasicOptions = environment.hazardConfig?.isBasicOptions;

export function getHazardTemplateFieldId(entity: HazardExportEntity) {
  switch (entity) {
    case HazardExportEntity.Cause:
      return 'causeTemplateId';
    case HazardExportEntity.Control:
      return 'controlTemplateId';
    case HazardExportEntity.Action:
      return 'actionTemplateId';
    case HazardExportEntity.TraceabilityReport:
      return 'traceabilityTemplateId';
    case HazardExportEntity.eClinicalReport:
      return 'eClinicalTemplateId';
  }
}

export function getHazardTemplateFieldName(entity: HazardExportEntity) {
  switch (entity) {
    case HazardExportEntity.Cause:
      return 'causeTemplate';
    case HazardExportEntity.Control:
      return 'controlTemplate';
    case HazardExportEntity.Action:
      return 'actionTemplate';
    case HazardExportEntity.TraceabilityReport:
      return 'traceabilityTemplate';
    case HazardExportEntity.eClinicalReport:
      return 'eClinicalTemplate';
  }
}

export function getRiskLabel(rpnValue: number) {
  const range = isBasicOptions
    ? { green: 1, yellow: 4, red: 7 }
    : { green: 1, yellow: 5, red: 11 };

  if (rpnValue >= range.red) {
    return 'Red';
  } else if (rpnValue >= range.yellow) {
    return 'Yellow';
  } else if (rpnValue >= range.green) {
    return 'Green';
  } else {
    return 'N/A';
  }
}

export function getHazardRiskLevel(value: number) {
  const range = isBasicOptions
    ? { veryLow: 1, low: 1, medium: 4, high: 7 }
    : { veryLow: 1, low: 7, medium: 13, high: 19 };

  if (value >= range.high) {
    return HazardRisk.High;
  } else if (value >= range.medium) {
    return HazardRisk.Medium;
  } else if (value >= range.low) {
    return HazardRisk.Low;
  } else {
    return HazardRisk.VeryLow;
  }
}
